import { Expandable } from "./Expandable.js";

/**
 * Class to implement the expandable manager
 * as a singleton, which can be instantiated by
 * any other extension as a dependency
 */
export class ExpandableManager
{
    private static manager: ExpandableManager;
    private instances: Expandable[] = [];

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor()
    {
        this.scopes.forEach(scope => {
            this.instances.push(new Expandable(scope));
        });
    }

    /**
     * Method to instantiate all
     * expandables on the current page
     *
     * @param {boolean} [reset=false]
     * @returns {ExpandableManager}
     */
    public static use(reset: boolean = false): ExpandableManager
    {
        if (!ExpandableManager.manager || reset) {
            ExpandableManager.manager = new ExpandableManager();
        }
        return ExpandableManager.manager;
    }

    /**
     * Selects the expandables
     *
     * @returns {NodeListOf<HTMLElement>}
     */
    protected get scopes(): NodeListOf<HTMLElement>
    {
        return document.querySelectorAll(`[expandable]`);
    }

    /**
     * Returns the number of instances
     *
     * @returns {number}
     */
    public get length(): number
    {
        return this.instances.length;
    }
}
